import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ClientAPIKey } from "@/openai";

export type ModelType = {
  name: string;
  displayName?: string;
  apiKey?: ClientAPIKey;
  supportsTemperature?: boolean;
};

export const AVAILABLE_MODELS: ModelType[] = [
  {
    name: "Human",
  },
  //   {
  //     name: "arcticfly/tic-tac-toe-llama-8b-001-23",
  //     displayName: "tic-tac-toe-llama-8b",
  //     apiKey: ClientAPIKey.TOGETHER,
  //   },
  {
    name: "arcticfly/tic-tac-toe-llama-8b-006-34",
    displayName: "tic-tac-toe-llama-8b-006",
    apiKey: ClientAPIKey.TOGETHER,
    supportsTemperature: true,
  },
  {
    name: "arcticfly/tic-tac-toe-llama-8b-shadowmaster-001-60",
    displayName: "tic-tac-toe-llama-8b-shadowmaster-60",
    apiKey: ClientAPIKey.TOGETHER,
    supportsTemperature: true,
  },
  {
    name: "arcticfly/tic-tac-toe-llama-8b-shadowmaster-001-64",
    displayName: "tic-tac-toe-llama-8b-shadowmaster-64",
    apiKey: ClientAPIKey.TOGETHER,
    supportsTemperature: true,
  },
  {
    name: "arcticfly/tic-tac-toe-llama-8b-shadowmaster-001-96",
    displayName: "tic-tac-toe-llama-8b-shadowmaster-96",
    apiKey: ClientAPIKey.TOGETHER,
    supportsTemperature: true,
  },
  {
    name: "arcticfly/tic-tac-toe-llama-8b-shadowmaster-001-128",
    displayName: "tic-tac-toe-llama-8b-shadowmaster-128",
    apiKey: ClientAPIKey.TOGETHER,
    supportsTemperature: true,
  },
  {
    name: "arcticfly/tic-tac-toe-llama-8b-shadowmaster-001-196",
    displayName: "tic-tac-toe-llama-8b-shadowmaster-196",
    apiKey: ClientAPIKey.TOGETHER,
    supportsTemperature: true,
  },
  {
    name: "gpt-4.1-2025-04-14",
    apiKey: ClientAPIKey.OPENAI,
    supportsTemperature: true,
  },
  {
    name: "gpt-4o-2024-11-20",
    apiKey: ClientAPIKey.OPENAI,
    supportsTemperature: true,
  },
  {
    name: "gpt-4o-mini-2024-07-18",
    apiKey: ClientAPIKey.OPENAI,
    supportsTemperature: true,
  },
  {
    name: "o4-mini",
    apiKey: ClientAPIKey.OPENAI,
  },
] as const;

export const getStoredModel = (label: string): ModelType => {
  const stored = localStorage.getItem(`tictactoe-${label.toLowerCase()}-model`);
  if (!stored) return AVAILABLE_MODELS[0];

  try {
    const parsed = JSON.parse(stored);
    const model = AVAILABLE_MODELS.find((m) => m.name === parsed.name);
    return model || AVAILABLE_MODELS[0];
  } catch {
    return AVAILABLE_MODELS[0];
  }
};

interface TicTacToeModelSelectorProps {
  value: ModelType;
  onChange: (value: ModelType) => void;
  label: string;
}

export const TicTacToeModelSelector: React.FC<TicTacToeModelSelectorProps> = ({
  value,
  onChange,
  label,
}) => {
  const handleChange = (newValue: string) => {
    const model =
      AVAILABLE_MODELS.find((m) => m.name === newValue) || AVAILABLE_MODELS[0];
    localStorage.setItem(
      `tictactoe-${label.toLowerCase()}-model`,
      JSON.stringify(model)
    );
    onChange(model);
  };

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium">{label}</label>
      <Select value={value.name} onValueChange={handleChange}>
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {AVAILABLE_MODELS.map((model) => (
            <SelectItem key={model.name} value={model.name}>
              {model.displayName || model.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
